import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogDiv, FormHr } from "../../../style";
import Buttons, { ButtonType } from "../../inputs/buttons/Buttons";
import LoadingButtons from "./LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

type DialogBoxProps = {
  open: boolean;
  onClose?: () => void;
  title?: string;
  dialogContent?: React.ReactNode;
  positiveButton?: {
    onPress: () => void;
    text: string;
    variant?: any;
    color?: any;
  };
  negativeButton?: {
    onPress: () => void;
    text: string;
    variant?: any;
    color?: any;
  };
  type?: "Add" | "Edit" | "Delete" | "ok" | "Adding" | "Editing";
  onSubmit?: () => void;
  loading?: boolean;
  /** default lg but overridable */
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
};

export const DialogBox: React.FC<DialogBoxProps> = (props) => {
  return (
    <DialogDiv
      {...props}
      fullWidth
      maxWidth={props.maxWidth || "lg"}
      onClose={props.onClose} // Allow outside click / Esc key to close
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          margin: "16px",
          borderRadius: "12px",
          "@media (max-width:600px)": { maxWidth: "95%", margin: "8px" },
          "@media (min-width:601px) and (max-width:1024px)": { maxWidth: "80%" },
          "@media (min-width:1025px)": {
            maxWidth: props.maxWidth === "lg" ? "960px" : "600px",
          },
        },
      }}
    >
 {props.title && (
  <>
    <DialogTitle
      sx={{
        fontWeight: 600,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {props.title}
      {props.onClose && (
        <IconButton
          onClick={props.onClose}
          sx={{
            color: "black", // set icon color
            fontSize: "28px", // bigger icon
            "& .MuiSvgIcon-root": {
              fontSize: "28px", // ensure svg size
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </DialogTitle>
    <FormHr />
  </>
)}

      <div
        style={{
          padding: "16px 24px",
          maxHeight: "60vh", // limit height
          overflowY: "auto", // scroll when content overflows
        }}
      >
        {props.dialogContent}
      </div>

      <DialogActions sx={{ paddingRight: "24px", paddingBottom: "20px" }}>
        {props.negativeButton && (
          <Buttons
            sx={{ float: "right" }}
            onClick={props.negativeButton.onPress}
            variant={props.negativeButton.variant}
            content={props.negativeButton.text}
            color={props.negativeButton.color}
          />
        )}
        {props.positiveButton && (
          <Buttons
            sx={{ float: "right" }}
            onClick={props.positiveButton.onPress}
            variant={props.positiveButton.variant}
            content={props.positiveButton.text}
            color={props.positiveButton.color}
          />
        )}
        {props.type && ["Add", "Edit", "Delete", "ok"].includes(props.type) && (
          <Buttons
            type="submit"
            onClick={props.onSubmit}
            variant={ButtonType.contained}
            content={
              props.type === "Add"
                ? "Submit"
                : props.type === "Edit"
                ? "Update"
                : props.type === "Delete"
                ? "Delete"
                : "Ok"
            }
          />
        )}
        {props.type && ["Adding", "Editing"].includes(props.type) && (
          <LoadingButtons
            onClick={props.onSubmit}
            loading={props.loading}
            loadingPosition="end"
            variant={ButtonType.contained}
            content={props.type === "Adding" ? "Submit" : "Update"} children={undefined}          />
        )}
      </DialogActions>
    </DialogDiv>
  );
};

